var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page"},[_c('first-screen'),_c('Insights'),_c('image-gallery'),_c('hardware-system'),_c('Cases'),_c('question-section'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }